export const TOGGLE_PRIMARY_SIDEBAR = "TOGGLE_PRIMARY_SIDEBAR";
export const SET_PRIMARY_SIDEBAR_DATA = "SET_PRIMARY_SIDEBAR_DATA";
export const TOGGLE_USER_SETTINGS = "TOGGLE_USER_SETTINGS";
export const TOGGLE_KEEP_SIDEBAR_OPENED = "TOGGLE_KEEP_SIDEBAR_OPENED";
export const TOGGLE_SOLUTION_USERS = "TOGGLE_SOLUTION_USERS";
